import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=8f65ca6e&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=8f65ca6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f65ca6e",
  null
  
)

export default component.exports